var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77603 6.69616C8.07599 6.99613 8.07599 7.47607 7.77603 7.77603C7.62805 7.92401 7.43207 8 7.2361 8C7.04012 8 6.84414 7.92401 6.69616 7.77603L4.0005 5.08036L1.30484 7.77603C1.15286 7.92401 0.96088 8 0.764904 8C0.568929 8 0.372953 7.92401 0.224972 7.77603C-0.0749906 7.47607 -0.0749906 6.99613 0.224972 6.69616L2.92063 4.0005L0.224972 1.30484C-0.0749906 1.00487 -0.0749906 0.524934 0.224972 0.224972C0.520935 -0.0749906 1.00487 -0.0749906 1.30484 0.224972L4.0005 2.92063L6.69616 0.224972C6.99613 -0.0749906 7.47607 -0.0749906 7.77603 0.224972C8.07599 0.520935 8.07599 1.00487 7.77603 1.30484L5.08036 4.0005L7.77603 6.69616Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossWhite);
export default __webpack_public_path__ + "static/media/cross-white.719195b56c6c83fc05b89ecc9fd374d6.svg";
export { ForwardRef as ReactComponent };